<template>
  <div class="main">

    <section>
      <div class="intro">
        <div class="fontSemiBold16 intro__headline">Thanks.</div>
        <p class="intro__text">Wir sagen euch Danke dafür, dass wir 2019 das Vertrauen erhalten haben, unter anderem folgende Projekte zu realisieren:</p>
      </div>
    </section>

    <section>
      <div class="col col--left">
        <div class="box" :class="{mounted: isMounted}">
          <boxHeader
            v-bind:counterNumber=15
            v-bind:counterUnit="'k'"
            v-bind:text="'Enterprise CMS Livegänge'">
          </boxHeader>
          <boxContent
            v-bind:label="'Mehr'">
          </boxContent>
        </div>

        <div class="box" :class="{mounted: isMounted}">
          <figure class="box__logo">
            <img
              src="/src/assets/img/thalia-logo.svg"
              alt="Thalia-Logo"
              width="100%"
              height="auto">
          </figure>
          <boxHeader
            v-bind:headline="'Crafter CMS'"
            v-bind:text="'erfolgreich bei Thalia eingeführt'">
          </boxHeader>
          <boxContent></boxContent>
        </div>

        <div class="box" :class="{mounted: isMounted}">
          <videoEmbed
            v-bind:url="'https://www.youtube-nocookie.com/embed/qG7TT8-Ebtc'"></videoEmbed>
          <boxHeader
            v-bind:headline="'Boye Aarhus 19'"
            v-bind:text="'Short List Small Feature Award'">
          </boxHeader>
          <boxContent></boxContent>
        </div>
      </div>

      <div class="col">
        <div class="box" :class="{mounted: isMounted}">
          <boxHeader
            v-bind:counterNumber=25
            v-bind:counterUnit="'k'"
            v-bind:text="'Intranetuser'">
          </boxHeader>
          <boxContent
            v-bind:label="'Mehr'">
          </boxContent>
        </div>

        <div class="box" :class="{mounted: isMounted}">
          <boxHeader
            v-bind:counterNumber=55
            v-bind:counterUnit="'k statt 30k'"
            v-bind:text="'App Ziel mehr als erreicht'">
          </boxHeader>
          <boxContent></boxContent>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import boxHeader from '../components/boxHeader.vue';
import videoEmbed from '../components/videoEmbed.vue';
import boxContent from '../components/boxContent.vue';

export default {
  name: 'en_home',
  components: {
    boxHeader, videoEmbed, boxContent,
  },
  data() {
    return {
      isMounted: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isMounted = true;
    }, 250);
  },
};
</script>
